import i18n from '@/i18n';
import { UndergradDiscipline } from '@/models/undergrad/undergrad-discipline.model';

export interface DisciplinesGroup {
  name: string;
  description: string;
  disciplines: UndergradDiscipline[];
}

export const groupDisciplinesByType = (classrooms: UndergradDiscipline[]): DisciplinesGroup[] => {
  const defaultGroup: DisciplinesGroup = {
    name: '',
    description: '',
    disciplines: [],
  };
  const complementaryGroup: DisciplinesGroup = {
    name: i18n.t('complementaries') as string,
    description: '',
    disciplines: [],
  };
  const levelingGroup: DisciplinesGroup = {
    name: i18n.t('leveling') as string,
    description: '',
    disciplines: [],
  };

  classrooms.forEach((classroom) => {
    switch (classroom.submoduleType) {
      case 'COMPLEMENTAR':
        complementaryGroup.disciplines.push(classroom);
        break;
      case 'ELETIVA':
        levelingGroup.disciplines.push(classroom);
        break;
      default:
        defaultGroup.disciplines.push(classroom);
    }
  });

  const groups = [defaultGroup, complementaryGroup, levelingGroup];
  return groups.filter((group) => group.disciplines.length);
};
